import { Component, OnDestroy, HostListener, ViewChild, AfterViewInit, isDevMode } from '@angular/core';
import { MessageService } from 'primeng/api';
import { AppBreadcrumbService } from '../../services/app.breadcrumb.service';
import { Subscription } from 'rxjs';
import { AppConfig } from 'src/app/domain/appconfig';
import { ConfigService } from 'src/app/services/app.config.service';
import { ArchiveSearchObject, ShipmentService } from 'src/app/services/shipment.service';
import { FormControl, FormGroup } from '@angular/forms';
import { HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { DomSanitizer } from '@angular/platform-browser';
import { DatePipe, formatDate } from '@angular/common';
import { LabelService } from 'src/app/services/label.service';
import { TranslateService } from '@ngx-translate/core';
import { ShipmentGraphService } from 'src/app/services/shipment-graph.service';
import { ClientService } from 'src/app/services/client.service';
import { DeviceAgentSerivce, getOS } from 'src/app/services/DeviceAgent.service';
import { ActivatedRoute } from '@angular/router';
import { PrintLabelShipmentDialogComponent } from '../Shared/dialogs/print-label-shipment-dialog/print-label-shipment-dialog.component';
import { DialogService } from 'primeng/dynamicdialog';
import { OBPermisssionsLocal } from 'src/app/services/auth.service';
import { Table } from 'primeng/table';

@Component({
  templateUrl: './archive.component.html',
  styleUrls: ['./archive.component.scss'],
})
export class ArchiveComponent implements OnDestroy, AfterViewInit {
  @ViewChild('waybillno') waybillNoField: any;
  @ViewChild('deliveryCalendar') deliveryCalendar: any;
  @ViewChild('bookingCalendar') bookingCalendar: any;
  @ViewChild("dt1") Maintable!: Table;

  config: AppConfig;
  subscription: Subscription;
  sortings = [{ name: 'Modtaget dato', code: 'receivedDate' }];
  dropDownValue = [{ name: 'Alle', code: 'All' }];
  shipment: any;
  shipments = this.shipmentService.archiveResultSet$ // ArchiveSearchObject | any;
  chosenShipmentId: any;
  pdfUrl: any;
  searchValues: any;
  selectedShipments: any;
  searchIsFocused: boolean = false;
  searching: boolean = true;
  options = { day: '2-digit', month: '2-digit', year: 'numeric' };
  tenantLogo: any;
  loading: boolean = false;
  printBeforeReadyPermission = OBPermisssionsLocal.printLabelBeforeReady;
  services = this.clientService.clientServices$;
  ServicesToBeSleceted = new Array<any>();
  sideBarOpen = true;
  searchForm = new FormGroup({
    barcode: new FormControl(null),
    senderName: new FormControl(null),
    waybillNo: new FormControl(null),
    senderZip: new FormControl(null),
    trackAndTrace: new FormControl(null),
    recipientName: new FormControl(null),
    recipientZip: new FormControl(null),
    reference1: new FormControl(null),
    reference2: new FormControl(null),
    reference3: new FormControl(null),
    note: new FormControl(null),
    ServicesCodesToLookFor: new FormControl(null),
    bookingDate: new FormControl<Date[] | null>([]),
    deliveryDate: new FormControl<Date[] | null>([]),
  });

  searchFormV2 = new FormGroup({
    barcode: new FormControl(null),
    waybillNo: new FormControl(null),
    trackAndTrace: new FormControl(null),
    clientNo: new FormControl(null),
    reference1: new FormControl(null),
    reference2: new FormControl(null),
    reference3: new FormControl(null),
    ServicesCodesToLookFor: new FormControl(new Array<any>()),
    senderName: new FormControl(null),
    recipientName: new FormControl(null),
    senderZip: new FormControl(null),
    recipientZip: new FormControl(null),
    ddOmexOwner: new FormControl(null),
    ddOmexPickup: new FormControl(null),
    ddOmexVia: new FormControl(null),
    ddOmexDelivery: new FormControl(null),
    ddOmexDate: new FormControl(new Array<Date>()),
    note: new FormControl(null),
    pickupDate: new FormControl<Date[] | null>([]),
    Page: new FormControl(1),
    PageSize: new FormControl(25),
    NamedSortField: new FormControl("bookingDate"),
    SortOrder: new FormControl(1),
    bookingDate: new FormControl<Date[] | null>([]),
    deliveryDate: new FormControl<Date[] | null>([]),
    status: new FormControl(
      [
        ShipmentStatus.Cancelled,
        ShipmentStatus.Deleted,
        ShipmentStatus.Picked_Up,
        ShipmentStatus.Ready,
        ShipmentStatus.At_Terminal,
        ShipmentStatus.Done,
        ShipmentStatus.Delivered,
        ShipmentStatus.In_Progress,
        ShipmentStatus.In_Transit,
        ShipmentStatus.Booked]),
    ShipmentAcceseRigths: new FormControl(['OWNER', 'ADMIN', 'NOBODY']),
    ShouldCount: new FormControl(true)
  });

  @HostListener('document:keydown.escape', ['$event']) onKeydownEscapeHandler(event: KeyboardEvent) {
    if (!this.searching) {
      this.clearChoice();
    }
  }
  @HostListener('document:keydown.backspace', ['$event'])
  onKeydownBackHandler(event: KeyboardEvent) {
    if (!this.searchIsFocused && !this.searching) {
      this.clearChoice();
    }
  }

  constructor(
    private breadcrumbService: AppBreadcrumbService,
    public configService: ConfigService,
    private messageService: MessageService,
    private sanitizer: DomSanitizer,
    private datePipe: DatePipe,
    private labelService: LabelService,
    private translateService: TranslateService,
    private shipmentGraphService: ShipmentGraphService,
    private shipmentService: ShipmentService,
    private clientService: ClientService,
    private deviceAgentSerivce: DeviceAgentSerivce,
    private route: ActivatedRoute,
    private dialogService: DialogService,
  ) {
    this.breadcrumbService.setItems([{ label: 'Arkiv', routerLink: ['archive'] }]);

    this.config = this.configService.config;
    this.subscription = this.configService.configUpdate$.subscribe((config) => {
      this.config = config;
    });

    this.tenantLogo = this.clientService.clientTenantLogo;
    this.route.url.subscribe(x => {
      if (x[x.length - 1].path.includes('-')) {

        let temp = x[x.length - 1].path;
        this.shipmentService.GetGroupedShipmentById(temp).subscribe(y => {
          let temparr = y.items.map((u: any) => (
            {
              id: u.id,
              bookingDate: u.bookingDate,
              bookingSource: u.bookingSource,
              eventDate: u.eventDate,
              recipientName: u.recipientName,
              reference1: u.reference1,
              status: u.status,
              waybillNo: u.waybillNo,
              senderName: u.senderName
            } as ArchiveSearchObject));
          this.shipments.next(temparr);
          this.searching = false;
        }
        )
      }
    })

    this.searchFormV2.controls.clientNo.setValue([this.clientService.defaultClientNumber], { emitEvent: false });
    this.shipments.subscribe(x => this.searching = false)
  }

  resetForm() {
    this.searchFormV2.reset();
    this.waybillNoField.nativeElement.focus();
  }

  performGraphSearch() {
    this.clearChoice();
    this.searching = true;
    this.sideBarOpen = false;
    this.loading = false;
    const formData = this.searchFormV2.value;
    this.shipmentService.SearchArchiveV3VisShipmentService(this.searchFormV2.getRawValue(), false)
    // if (Object.values(formData).every((x) => x === null || x === '' || x.length === 0)) {
    //   this.messageService.add({
    //     severity: 'info',
    //     summary: this.translateService.instant('MESSAGES.PLEASEFILLATLEASTONEFIELD'),
    //   });
    //   return;
    // }
    // this.shipmentGraphService
    //   .graphSearch(
    //     formData.barcode,
    //     formData.waybillNo,
    //     formData.trackAndTrace,
    //     formData.reference1,
    //     formData.reference2,
    //     formData.reference3,
    //     formData.ServicesCodesToLookFor,
    //     formData.senderName,
    //     formData.recipientName,
    //     formData.senderZip,
    //     formData.recipientZip,
    //     formData.note,
    //     formData.bookingDate ? formData.bookingDate[0] : null,
    //     formData.bookingDate ? formData.bookingDate[1] : null,
    //     formData.deliveryDate ? formData.deliveryDate[0] : null,
    //     formData.deliveryDate ? formData.deliveryDate[1] : null
    //   )
    //   .subscribe({
    //     next: (res: ArchiveSearchObject[]) => {
    //       this.shipments = [...res];
    //     },
    //     error: (error) => {
    //       console.error('Error while searching', error);
    //     },
    //   })
    //   .add(() => {
    //     this.searching = false;
    //   });
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      if (this.waybillNoField && this.waybillNoField.nativeElement) {
        this.waybillNoField.nativeElement.focus();
      }
    }, 100);
  }

  onRowSelect(event: any) {
    if (event.data) {
      this.shipment = event.data;
      this.chosenShipmentId = event.data.id;
      this.pdfUrl = null;
      this.loading = false;
    }
  }

  tooltipText(simpleShipment: any) {
    if (simpleShipment) {
      return simpleShipment.eventDate != null ? this.datePipe.transform(simpleShipment.eventDate, 'dd/MM/yyyy HH:mm:ss') : '';
    }
    return '';
  }

  async printShipment(type: any): Promise<void> {

    if (!this.selectedShipments) {
      this.messageService.add({ severity: 'info', summary: this.translateService.instant('MESSAGES.CHOOSESHIPMENTFORPRINT') });
      return;
    }

    // this.loading = true;
    this.chosenShipmentId = null;
    // this.shipment = null;

    var shipmentIds = this.selectedShipments.map((shipment) => shipment.id);

    if (shipmentIds) {
      let queryParams = new HttpParams().append('printType', type);
      for (let shipmentId of shipmentIds) {
        queryParams = queryParams.append('shipmentIds', shipmentId);
      }

      if (type === 'shipment') {
        this.loading = false;
        this.dialogService.open(PrintLabelShipmentDialogComponent, {
          width: '70vw',
          data: { id: shipmentIds, type: 'shipment' },
          header: 'shipment ',
        }).onClose.subscribe(result => {
          if (result)
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error Occured, Try again' });
        });
        return;
      }
      else if (getOS() === 'iOS') {
        const url = type === "label" ? await this.labelService.getMultipleLabels(shipmentIds) : `${environment.apiUrl}/shipments/print?${queryParams.toString()}`;
        await this.deviceAgentSerivce.PrintLabelFromIOS(shipmentIds, type, queryParams);

      } else {
        if (type == 'label') {
          // this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(await this.labelService.getMultipleLabels(shipmentIds));
          if (this.selectedShipments.filter(x => x.status == "BOOKED").length > 0 && !this.clientService.hasClientPermission(this.printBeforeReadyPermission))
            this.messageService.add({ severity: "info", detail: "ikke klarmeldte label print", summary: "man kan ikke printe labels før sending er klarmeldt, fravælg ikke klarmeldted sending og forsøg igen" })

          if (this.selectedShipments.filter(x => x.status != "BOOKED").length > 0 || this.clientService.hasClientPermission(this.printBeforeReadyPermission)) {

            let labelFromPrint = this.clientService.hasClientPermission(this.printBeforeReadyPermission) ?
              await this.labelService.getMultipleLabelsV2(this.selectedShipments.map(y => y.id))
              : await this.labelService.getMultipleLabelsV2(this.selectedShipments.filter(x => x.status != "BOOKED").map(y => y.id));
            let pdfblob = await this.base64ToBlob(labelFromPrint as Uint8Array) // from base64 to blob
            this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(pdfblob)); // this.pdfUrl to be shown in html   

            this.dialogService.open(PrintLabelShipmentDialogComponent, {
              width: '70vw',
              data: { id: shipmentIds, type: 'label', isLabel: true, pdfurl: this.pdfUrl },
              header: 'labels ',
            }).onClose.subscribe(result => {
              if (result)
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error Occured, Try again' });
            });


          } else {
            this.messageService.add({ severity: "info", detail: "ikke klarmeldte label print", data: "man kan ikke printe labels før sending er klarmeldt" })
          }

        } else {
          this.PrintPakgeListFromLabelService(shipmentIds);
          // this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(`${environment.apiUrl}/shipments/print?${queryParams.toString()}`);
        }
      }

    }
    this.loading = false;
  }


  async base64ToBlob(base64: Uint8Array | Blob, mime = 'application/pdf') {
    if (typeof base64 == typeof Blob) {
      let arg = (await (base64 as Blob).stream().getReader().read()).value;
      return new Blob([arg], { type: mime })
    } else {
      const byteArray = new Uint8Array(base64 as Uint8Array);
      return new Blob([byteArray], { type: mime });
    }
  }



  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  notImplemented() {
    this.messageService.add({
      severity: 'info',
      summary: this.translateService.instant('MESSAGES.NOTIMPLEMENTED'),
    });
  }

  clearChoice() {
    if (this.shipment) {
      this.shipment = null;
    }
    if (this.selectedShipments) {
      this.selectedShipments = [];
    }
    if (this.chosenShipmentId) {
      this.chosenShipmentId = null;
    }
    if (this.pdfUrl) {
      this.pdfUrl = null;
    }
    this.loading = false;
  }
  PrintPakgeListFromLabelService(_shipmentIds: string[]) {
    this.loading = true;
    this.labelService.PrintPackageListFromLabelService(_shipmentIds)
      .subscribe({
        next: (res: any) => {
          this.loading = false;

          const base64 = (res.data || '').trim();

          if (!base64) {
            console.error('No PDF data returned', res);
            return;
          }

          const byteString = atob(base64);
          const bytes = new Uint8Array(byteString.length);

          for (let i = 0; i < byteString.length; i++) {
            bytes[i] = byteString.charCodeAt(i);
          }

          const blob = new Blob([bytes], {
            type: res.contentType || 'application/pdf'
          });

          const url = URL.createObjectURL(blob);

          const win = window.open('about:blank', '_blank', 'popup');

          if (win) {
            win.document.title = res.fileName || 'Package List';
            win.document.body.style.margin = '0';
            win.document.body.innerHTML =
              `<iframe src="${url}" style="border:0;width:100vw;height:100vh;"></iframe>`;

            win.addEventListener('beforeunload', () => URL.revokeObjectURL(url));
          } else {
            window.location.href = url;
          }
        },
        error: err => {
          this.loading = false;
          console.error('Failed to print package list', err);
        }
      });
  }
  ShipmentsOrderBy(): string[] {
    let sortField = this.Maintable.sortField as string | undefined;//   this.searchForm.controls.NamedSortField.value
    let sortOrder = this.Maintable.sortOrder ?? 1;
    return this.selectedShipments
      .sort((a: any, b: any) => {
        if (!sortField)
          return 0;
        if (sortField === 'waybillNo') {          
          return ((a.waybillNo as number - b.waybillNo as number) > 0 ? 1 : -1) * sortOrder;
        }
        if (sortField === 'bookingDate')
          return (new Date(a.bookingDate).getTime() - new Date(b.bookingDate).getTime()) * sortOrder;
        if (sortField == 'recipientZip')
          return (a.recipientZip - b.recipientZip) * sortOrder;
        if (sortField == 'recipientName')
          return String(a.recipientName).localeCompare(String(b.recipientName)) * sortOrder;
        if (sortField == 'clientName')
          return String(a.clientName).localeCompare(String(b.clientName)) * sortOrder;
        if (sortField == 'status')
          return String(a.status).localeCompare(String(b.status)) * sortOrder;
        if (sortField == 'bookingSource')
          return String(a.bookingSource).localeCompare(String(b.bookingSource)) * sortOrder;

        return String(a.waybillNo).localeCompare(String(b.waybillNo)) * sortOrder;
      })
      .map((x: any) => x.id);
  }
}


enum ShipmentStatus {
  Booked = 0,
  Ready = 1,
  Picked_Up = 5,
  At_Terminal = 7,
  In_Transit = 9,
  In_Progress = 10,
  Delivered = 20,
  Cancelled = 90,
  Done = 99,
  Deleted = -1,
}